export const StringUtils = {
  toTitleCase: (str?: string | null) =>
    typeof str === 'string'
      ? str.replace(/\w\S*/g, (txt: string) => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase())
      : str ?? undefined,
}
